import {register} from '@shopify/theme-sections'

import '../../styles/sections/section-custom-locations.scss'
import $ from "jquery"

export default register(`section-custom-locations`, {

    onLoad() {
        $(`.custom-locations-slider`).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            center: true,
            prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button>`,
            nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button>`,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        })
    },

    onUnload() {
    },
})
